export default __webpack_public_path__ + "files/c1531403643ea87a4ea8143fbd8d28c7.png";